import * as React from "react";

export const geoStatus = {
  pending: "pending",
  ok: "accepted",
  declined: "declined",
};

const useGeolocation = () => {
  const [access, setAccess] = React.useState(geoStatus.pending);
  const [cords, setCords] = React.useState(0);

  const handleDeclined = () => {
    localStorage.setItem("cords", geoStatus.declined);
    return setAccess(geoStatus.declined);
  };

  const handleError = (error) => {
    const PERMISSION_DENIED = 1;
    const { code } = error;

    switch (code) {
      case PERMISSION_DENIED:
        return handleDeclined();
      default:
        return handleDeclined();
    }
  };

  React.useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCords(position.coords.latitude);
      }, handleError);
    } else handleDeclined();
  }, []);

  React.useEffect(() => {
    if (cords) {
      setAccess(geoStatus.ok);
      localStorage.setItem("cords", JSON.stringify(cords));
    } else setAccess(geoStatus.pending);
  }, [cords]);

  return access;
};

export default useGeolocation;
